import React from "react";
import { Star, Quote, PenLine } from "lucide-react";
import StarRating from "./StarRating";
import { companyInfo } from "../data/mock";
import { testimonials } from "../data/mock";

const GOOGLE_URL = "https://www.google.com/maps?cid=11809739362119773457";

const Reviews = () => {
  return (
    <section
      id="reviews"
      className="py-24 bg-gradient-to-br from-slate-50 to-sky-50"
      aria-labelledby="reviews-heading"
      data-testid="reviews-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1 bg-amber-100 text-amber-700 rounded-full text-sm font-semibold mb-4">
            Klantbeoordelingen
          </span>
          <h2
            id="reviews-heading"
            className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-800 mb-4"
          >
            Wat onze klanten zeggen
          </h2>

          {/* Aggregate rating */}
          <div className="inline-flex items-center space-x-3 bg-white rounded-full px-6 py-3 shadow-md mt-2">
            <StarRating rating={companyInfo.rating} emptyClass="text-slate-200" />
            <span className="font-bold text-slate-800 text-lg">
              {companyInfo.rating}
            </span>
            <span className="text-slate-500">
              · {companyInfo.reviewCount} reviews op Google
            </span>
          </div>
        </div>

        {/* Reviews Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((review, index) => (
            <div
              key={review.id}
              className="relative bg-white rounded-2xl p-6 shadow-md hover:shadow-xl transition-all duration-300 flex flex-col"
              data-testid={`review-card-${index}`}
            >
              {/* Quote icon */}
              <Quote
                className="absolute top-4 right-4 w-8 h-8 text-sky-100"
                aria-hidden="true"
              />

              {/* Stars */}
              <div className="flex mb-3" aria-label={`${review.rating} van 5 sterren`}>
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    className={`w-4 h-4 ${
                      i < review.rating
                        ? "text-amber-400 fill-amber-400"
                        : "text-slate-200 fill-slate-200"
                    }`}
                  />
                ))}
              </div>

              {/* Body */}
              <p className="text-slate-700 leading-relaxed mb-5 flex-1">
                &ldquo;{review.text}&rdquo;
              </p>

              {/* Author */}
              <div className="flex items-center space-x-3 pt-4 border-t border-slate-100">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-sky-500 to-teal-500 flex items-center justify-center text-white font-bold flex-shrink-0">
                  {review.author.charAt(0)}
                </div>
                <div className="min-w-0">
                  <p className="font-semibold text-slate-800 truncate">
                    {review.author}
                  </p>
                  <p className="text-xs text-slate-500">
                    {review.source} · {review.date}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-12">
          <a
            href={GOOGLE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center space-x-2 text-sky-600 font-semibold hover:text-sky-700 transition-colors"
            data-testid="all-reviews-link"
          >
            <span>Bekijk alle {companyInfo.reviewCount} reviews op Google</span>
            <span aria-hidden="true">&rarr;</span>
          </a>
          <a
            href={GOOGLE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl border-2 border-slate-200 text-slate-700 font-semibold hover:border-sky-400 hover:text-sky-600 transition-colors bg-white"
            data-testid="write-review-link"
          >
            <PenLine className="w-4 h-4" />
            Bent u klant? Laat een review achter
          </a>
        </div>
      </div>
    </section>
  );
};

export default Reviews;
